'use client'

import Link from 'next/link'
import React from 'react'

import {
  MapHoverCardShell,
  mapHoverCardPrimaryLinkClassName,
} from '@/components/Location/MapHoverCardShell'
import type { MapCityCardData } from '@/lib/cities/mapCityData'
import { useMessages } from '@/lib/i18n/useMessages'
import { cn } from '@/utilities/ui'

type CityMapHoverCardProps = {
  city: MapCityCardData
  className?: string
  closeLabel?: string
  id?: string
  onClose?: () => void
  viewCityLabel: string
}

export function CityMapHoverCard({
  city,
  className,
  closeLabel,
  id,
  onClose,
  viewCityLabel,
}: CityMapHoverCardProps) {
  const description = useMessages().landing.locationsMap.hoverDescriptions[city.slug]

  return (
    <MapHoverCardShell
      actions={
        <Link className={cn(mapHoverCardPrimaryLinkClassName, 'w-full')} href={city.viewCityHref}>
          {viewCityLabel}
        </Link>
      }
      className={className}
      closeLabel={closeLabel}
      description={description}
      id={id}
      name={city.name}
      onClose={onClose}
      previewImage={city.previewImage}
      previewImageAlt={city.previewImageAlt}
    />
  )
}
